// extracted by mini-css-extract-plugin
module.exports = {"QualInput":"QualInput_QualInput__3Nx3d","FirstRow":"QualInput_FirstRow__1Nbkf","SecondRow":"QualInput_SecondRow__1aJKc"};